import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function TrialBanner() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.account_type === "collaborator") return null;
  if (user.subscription_status === "active" || user.comp_granted) return null;
  if (user.subscription_status === "locked") return null;

  // Use server-computed countdown (immune to client clock skew).
  const days = user.trial_days_remaining;
  if (days === undefined || days === null) return null;

  const urgent = days <= 2;

  return (
    <div
      data-testid="trial-banner"
      className={`text-xs px-4 py-2 flex items-center justify-center gap-3 ${urgent ? "bg-[var(--brand-soft)] text-[var(--brand-hover)]" : "bg-[var(--warm-accent)] text-[var(--ink-secondary)]"}`}
    >
      <span className="font-ui tracking-wide">
        {days > 0
          ? `${days} day${days === 1 ? "" : "s"} left on your free trial`
          : "Your trial wraps today"}
      </span>
      <Link to="/account" className="underline underline-offset-2 hover:text-[var(--ink-primary)]" data-testid="trial-banner-cta">
        Add payment
      </Link>
    </div>
  );
}
